<div class="mt-3" id="versicherungsvariante" *ngIf="paket">
  <h6>Gewählte Versicherungsvariante</h6>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <strong>{{ (produkt.DeckungsumfangErhoehen === true ? 'Top ' : '') + 'Recht§vorteil - Paket ' + paket.PaketId + (produkt.FuerWenId === 1 || produkt.FuerWenId === 2 ? ' - Single/Alleinerzieher' : '') + ' (' + paket.Name + ')'}}</strong>
    </div>
  </div>
  <div class="row" *ngFor="let leistung of paket.Leistungen">
    <div class="leistung">
      <div class="col col-xs-12 col-sm-12">
        <p><strong>{{ leistung.Name }} </strong></p>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <p [innerHTML]="leistung.Beschreibung"></p>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col col-xs-12 col-sm-12">
    <div class="input" *ngIf="produkt.Kennzeichen">
      <label class="input__label" for="antrag_kennzeichen">Kennzeichen:</label>
      <mat-form-field>
        <input matInput id="antrag_kennzeichen" [value]="produkt.Kennzeichen | uppercase" disabled>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="mt-3">
  <h6>Errechnung der Prämie</h6>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input">
        <label class="input__label" for="versicherungssumme">Versicherungssumme (wertgesichert VPI 2000):</label>
        <mat-form-field>
          <input matInput id="versicherungssumme" [value]="versicherungssumme" disabled>
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <div class="input">
        <label class="input__label" for="praemie">{{ 'Prämie (' + (produkt.ZahlungArtId === 1 ? 'jährlich' : produkt.ZahlungArtId === 2 ? 'halbjährlich' : produkt.ZahlungArtId === 3 ? 'vierteljährlich' : produkt.ZahlungArtId === 4 ? 'monatlich' : null) + ')' }}</label>
        <mat-form-field>
          <input matInput id="praemie" [value]="rsResult?.Gesamt | customCurrency" disabled>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<div class="mt-3" id="antrag_weiterefragen">
  <h6>Allgemeine Fragen</h6>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input">
        <label class="input__label" for="antrag_fuerWen">Für wen soll der Versicherungsschutz bestehen?</label>
        <mat-form-field>
          <input matInput id="antrag_fuerWen" [value]="expertMode ? fuerWenOptionsExpert.get(produkt.FuerWenId) : fuerWenOptions.get(produkt.FuerWenId)" disabled>
        </mat-form-field>
      </div>
    </div>
  </div>
  <app-antrag-weitere-fragen [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="weitereFragen" [expertMode]="expertMode" [versicherungsArt]="'Rechtsschutzversicherung'" [showVorversicherungGroup]="true" (kuendigungRisikenEvent)="setKuendigungRisiken($event)"></app-antrag-weitere-fragen>
  <app-daten-beratungsprotokoll [showHeadLine]="false" [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="datenBeratungsprotokoll" [antrag]="true" [expertMode]="expertMode"></app-daten-beratungsprotokoll>
</div>
